export const defaultAddControl = {
  id: 'all',
  name: 'All',
  icon: 'lightbulb-group-outline',
  sort: -9999,
  isActive: false,
  entities: [],
};
